export default "__VITE_ASSET__BFHGeqcx__"